import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { getConsent } from '../lib/analytics';

export default function ConsentBanner({ onConsent }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Don't show if consent already given
    if (getConsent()) return;

    // Show after 1.5s delay to avoid competing with page content
    const timer = setTimeout(() => setVisible(true), 1500);
    return () => clearTimeout(timer);
  }, []);

  if (!visible) return null;

  const handleAccept = () => {
    setVisible(false);
    onConsent('all');
  };

  const handleDecline = () => {
    setVisible(false);
    onConsent('necessary');
  };

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[60] border-t border-neutral-200 bg-white/95 backdrop-blur-sm shadow-lg"
      style={{ paddingBottom: 'max(0.75rem, env(safe-area-inset-bottom))' }}
    >
      <div className="max-w-3xl mx-auto px-4 py-4 flex flex-col sm:flex-row items-start sm:items-center gap-3">
        <p className="text-sm text-neutral-600 flex-1">
          Vi bruker informasjonskapsler for å gi deg en bedre opplevelse og vise relevante annonser.{' '}
          <a href="/personvern" className="underline text-neutral-500 hover:text-neutral-800">
            Les mer
          </a>
        </p>
        <div className="flex gap-2 shrink-0">
          <button
            onClick={handleDecline}
            className="text-sm text-neutral-500 hover:text-neutral-800 px-3 py-2 transition-colors"
          >
            Bare nødvendige
          </button>
          <Button
            size="sm"
            onClick={handleAccept}
          >
            Godta
          </Button>
        </div>
      </div>
    </div>
  );
}
